import { FC } from "react";

import { CustomizedYAxisTickBarsProps } from "./CustomizedYAxisTickBars.type";

const CustomizedYAxisTickBars: FC<CustomizedYAxisTickBarsProps> = ({ x, y, fontSize, payload, xOffset = 0 }) => (
	<g transform={`translate(${x},${y})`}>
		<text x={xOffset} y={0} dy={0} textAnchor="end" alignmentBaseline="middle" fill="#444444" style={{ fontSize: `${fontSize || 12}px`, fontFamily: "Source Sans 3" }}>
			{payload.value}
		</text>
	</g>
);

export { CustomizedYAxisTickBars };
